const UserDetails = (state = [], action) => {
    switch (action.type) {
        case 'UserDetails_SUCCESS':
            return action.userData
        default:
            return state
    }
}
export default UserDetails